import * as API from "../../api";
import * as ActionTypes from "../action-types";

export const set_company_name = (company) => {
  return {
    type: ActionTypes.SET_COMPANY_NAME,
    company,
  };
};
